import { render, staticRenderFns } from "./AppCoreHeaderLeft.vue?vue&type=template&id=ef81d322&scoped=true"
import script from "./AppCoreHeaderLeft.vue?vue&type=script&lang=js"
export * from "./AppCoreHeaderLeft.vue?vue&type=script&lang=js"
import style0 from "./AppCoreHeaderLeft.vue?vue&type=style&index=0&id=ef81d322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef81d322",
  null
  
)

/* custom blocks */
import block0 from "./AppCoreHeaderLeft.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports